import { getIssueDetail, updateIssueVideo, updateIssue } from '@/api/issue';

import { useVuex } from 'common-module/src/util/useVuex';

/**
 * 关联录制视频到issue
 * @param {*} issueId
 * @param {*} videoUrl
 * @param {*} videoCode
 * @returns
 */
export async function relationRecordToIssue(issueId, videoUrl, videoCode, videoName) {
  if (!issueId){
    return;
  }
  const issueDetail = await getIssueDetail({ issueId });
  const description = issueDetail?.data?.description || '';
  const describeVideoCode = getVideoCodeFromDescribe(description);
  if (describeVideoCode.includes(videoCode)) {
    return;
  }
  describeVideoCode.push(videoCode);
  // 更新关联issue
  updateIssueVideo({
    issueId,
    videoCodes: describeVideoCode
  });
  const store = useVuex();
  const avatar = store.getters['user/avatar'] || '';
  const userName = store.getters['user/userName'] || '';
  const videoAuthor = JSON.stringify({ avatar: avatar, name: userName });

  // 更新事项描述
  updateIssue({
    id: issueId,
    data: {
      description: `${description}<div data-type="recorderVideo" data-video-url="${videoUrl}" data-video-code="${videoCode}" data-video-name="${videoName}" data-video-author='${videoAuthor}'></div>`
    }
  });
}

function getVideoCodeFromDescribe(description) {
  if (!description || !description.includes('data-type="recorderVideo"')){
    return [];
  }
  let tempEl = document.createElement('div');
  tempEl.innerHTML = description;
  const recorderEls = tempEl.querySelectorAll('div[data-type="recorderVideo"]');
  const codes = [...recorderEls].map(
    el => el.getAttribute('data-video-code')
  );
  tempEl.remove();
  tempEl = null;
  return codes;
}
